module.exports = __webpack_public_path__ + "b4a1fdeb6e47fdbbefb8d627a33381ee.svg";